module.exports = __webpack_public_path__ + "static/4.d17be973.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider/4.png
// module id = 448
// module chunks = 35783957827783